import React from "react";
import Deliverypartners from "../../components/EordersDeliveryPartners/Deliverypartners";
import Sidebar from "../../components/SideBar/sidebar";
import { SetHeading } from "../../context/NavbarContext";
import AllDeliveryBoys from "../settings/DeliveryBoy/AllDeliveryBoy";


const DeliveryPartner = () => {
  return (
    <div className="flex">
      <div className="flex flex-col flex-1  mt-14">
        <SetHeading value="delivery_boy" />
        <AllDeliveryBoys/>
        {/* <Deliverypartners  /> */}

       
      </div>
    </div>
  );
};

export default DeliveryPartner;
